import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ShopItemsService } from '@/modules/shop/api/services/ShopItemsService'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'

export default function useMutationApplyShopItemPreset() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (presetId: string) =>
			ShopItemsService.applyShopItemPreset(presetId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SHOP_QUERY_KEYS.ITEMS.ALL })
		},
	})
}
